import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-marketplace',
});

export const productsCatalogRouteRef = createSubRouteRef({
  id: 'wb-marketplace-dp-catalog',
  parent: rootRouteRef,
  path: '/list',
});
export const searchHomepageRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/home',
});
export const dataProductRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/search/:id/*',
});

export const dataProductLegacyRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/products-catalog/:id/*',
});

export const outputPortRouteRef = createSubRouteRef({
  id: 'wb-marketplace:outputPort',
  parent: rootRouteRef,
  path: '/consumable-interface/:id/*',
});

// route for the visual discovery
export const visualDiscovery = createSubRouteRef({
  id: 'wb-marketplace-visual-discovery',
  parent: rootRouteRef,
  path: '/visual-discovery',
});

export const dataContractsOverviewRouteRef = createSubRouteRef({
  id: 'wb-marketplace-data-contracts-overview',
  parent: rootRouteRef,
  path: '/data-contracts',
});

// route for the metadata graph
export const metadataGraph = createSubRouteRef({
  id: 'wb-marketplace-business-ontology-graph',
  parent: rootRouteRef,
  path: '/business-ontology-graph',
});

export const marketplaceSearchRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/search',
});

export const discoveryZoomInRouteRef = createSubRouteRef({
  id: 'wb-marketplace:system',
  parent: rootRouteRef,
  path: '/visual-discovery/:id/*',
});
